import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
// import moment from 'moment';

import Header from '../../components/Layouts/MyPage/Header/MyPageHeader.index';
import Footer from '../../components/Layouts/MyPage/Footer/MyPageFooter.index';

import { RootState } from '../../store/reducers';
import {
  GET_RESERVE_HISTORY_INITIAL,
  GET_RESERVE_HISTORY_REQUEST,
  RESERVE_HISTORY_DETAIL_STATE,
} from '../../store/actions';
import { GetReserveHistoryStateType } from '../../store/reducers/reserveHistory/getReserveHistoryReducer';

// import useAuthorizationNormal from '../../hooks/Auth/useAuthorizationNormal';

const ReservationHistory: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { isGetReserveHistoryLoaded, getReserveHistory } = useSelector<RootState, GetReserveHistoryStateType>(
    (state) => state.reserveHistory.getReserveHistory,
  );

  useEffect(() => {
    return () => {
      dispatch({
        type: GET_RESERVE_HISTORY_INITIAL,
      });
    };
  }, []);

  // useAuthorizationNormal();

  useEffect(() => {
    // if (sessionStorage.getItem('simpleAuthResult_visitorId')) {
    if (sessionStorage.getItem('simpleAuthResult_birthday') && sessionStorage.getItem('simpleAuthResult_telephone')) {
      window.scrollTo(0, 0);

      dispatch({
        type: GET_RESERVE_HISTORY_REQUEST,
        visitorId: null,
        birthday: sessionStorage.getItem('simpleAuthResult_birthday'),
        telephone: sessionStorage.getItem('simpleAuthResult_telephone'),
        history: null,
      });
    } else {
      const url = '/';
      history.push(url);
    }
  }, [history, dispatch]);

  const onClickReserveHistoryDetail = (historyId: string) => () => {
    dispatch({
      type: RESERVE_HISTORY_DETAIL_STATE,
      transitionTarget: true,
      historyId,
    });
    history.push('/history/detail');
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />

        <div className="reservation-history" style={{ flex: '1' }}>
          <main className="main-layout l-main">
            <section className="p-title-area">
              <p className="c-title">ご予約一覧</p>
            </section>

            {isGetReserveHistoryLoaded && getReserveHistory.data_list && getReserveHistory.data_list.length > 0 ? (
              <>
                <section className="p-content-area u-gap50">
                  <div className="p-content-area__column u-gap30 u-sp-gap15">
                    {getReserveHistory.data_list.length > 1 ? (
                      <>
                        <p className="c-read">認証情報に一致する予約が複数のため、該当する予約をご選択ください。</p>
                      </>
                    ) : (
                      <></>
                    )}

                    <div className="p-content-area__column p-content-area__column--width922 u-gap20 u-sp-gap40">
                      <ul className="p-event-list">
                        {getReserveHistory.data_list.map((rowItem, rowIndex) => {
                          return (
                            <>
                              {/* <!-- イベントアイテム --> */}
                              <li key={rowItem.data_id} className="p-event-list__item">
                                <div className="p-event-list__content">
                                  <div className="p-event-list__datetime">
                                    <span className="p-event-list__date">
                                      {rowItem.reserve_time_label?.split(' ')?.[0]}
                                    </span>
                                    <span className="p-event-list__time">
                                      {rowItem.reserve_time_label?.split(' ')?.[1]}
                                    </span>
                                  </div>
                                  <div className="p-event-list__info">
                                    <p className="p-event-list__location">
                                      {rowItem.club_web_show_name}
                                      {rowItem.club_equipment_annex_flag === 1 ? (
                                        <>
                                          <span className="c-genre-label">別館</span>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </p>
                                    {/* <div className="p-event-list__title">ヨガクラス（初心者向け）</div> */}
                                    <div className="p-event-list__title p-event-list__title--long">
                                      {rowItem.contents_web_show_name}
                                    </div>
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  className="p-event-list__button c-button c-button--primary c-button--small c-button--next"
                                  onClick={onClickReserveHistoryDetail(rowItem.data_id)}
                                >
                                  詳細を見る
                                </button>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </section>
              </>
            ) : isGetReserveHistoryLoaded ? (
              <>ご予約情報存在しません。</>
            ) : (
              <></>
            )}
          </main>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default ReservationHistory;
